module.exports = __webpack_public_path__ + "img/feedback_cancel.e23c8ac6.svg";